import { render, staticRenderFns } from "./VGoalItem.vue?vue&type=template&id=2a2a3f7d&scoped=true&"
import script from "./VGoalItem.vue?vue&type=script&lang=ts&"
export * from "./VGoalItem.vue?vue&type=script&lang=ts&"
import style0 from "./VGoalItem.vue?vue&type=style&index=0&id=2a2a3f7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2a3f7d",
  null
  
)

export default component.exports